import { Injectable } from '@angular/core';
import { AuthService, UserData } from 'src/app/core/account/auth.service';
import { User } from 'src/app/core/account/user.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { isExportDeclaration } from 'typescript';
import * as aesjs from 'aes-js';

const key = [ 210, 21, 32, 4, 45, 14, 27, 8, 9, 11, 111, 12, 13, 14, 35, 16 ];

@Injectable({ providedIn: 'root' })
export class IdentityService {
  authenticated: boolean;
  email: string;
  id: string;   
  firstName: string;
  lastName: string;
  memberId: number;
  phone: string;
  token: string;
  tokenExpiration: Date;
  public permissions: string[];
  apiHost: string = environment.apiHost;

  constructor(private http: HttpClient) {
    if (this.permissions == null) this.refreshLeader();
  }

  isLeader(userId: string) {
    var link = `${this.apiHost}/Permission/IsLeader?UserId=`;
    let promise = new Promise<boolean>((resolve, reject) => {
      let apiURL = link + userId;
      this.http
        .get<boolean>(apiURL)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (msg) => {
            resolve(false);
          }
        );
    });
    return promise;
  }

  hasAdmin(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasVolunteeringAdmin(): boolean {
    return (
      this.permissions.indexOf('Volunteering Admin') >= 0
      );
  }

  hasCheckIn(): boolean {  
    return (
      this.permissions.indexOf('Check-in') >= 0
    );
  }

  hasBase(): boolean {
    return (
      this.permissions.indexOf('Base') >= 0
    );
  }

  hasSuperAdmin(): boolean {
    return (
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasFormsView(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Form Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Form Editor') >= 0 ||
      this.permissions.indexOf('Form Viewer') >= 0 ||
      this.permissions.indexOf('Leader') >= 0
    );
  }

  hasFullAccessNotes(): boolean {
    return (
      this.permissions.indexOf('Notes Full Access') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Admin') >= 0
    );
  }

  hasFormEditor(): boolean {
    return (
      this.permissions.indexOf('Form Editor') >= 0 ||
      this.permissions.indexOf('Form Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Admin') >= 0
    );
  }

  hasFormAdmin(): boolean {
    return (
      this.permissions.indexOf('Form Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Admin') >= 0
    );
  }

  hasTaskAssignment(): boolean {
    return (
      this.permissions.indexOf('Task Assignment') >= 0 ||
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0
    );
  }

  hasProfileEditor(): boolean {
    return (
      this.permissions.indexOf('Profile Editor') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasProfileViewer(): boolean {
    return (
      this.permissions.indexOf('Profile Viewer') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0
    );
  }

  hasLeader(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 
          );
  }

  hasEventOrganizer(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Event Organizer') >= 0
    );
  }

  hasCMSAdministrator(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('CMS Administrator') >= 0
    );
  }

  hasForms(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Form Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0
    );
  }

  hasGroupAdmin(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Group Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasGiving(): boolean {
    return (
      this.permissions.indexOf('Giving') >= 0  ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasAttendance(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 ||
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Attendance Viewer') >= 0
    );
  }

  hasEvents(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Event Organizer') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 ||
      this.permissions.indexOf('Event Viewer') >= 0
    );
  }

  hasServiceSetup(): boolean {
    return (
      this.permissions.indexOf('Event Organizer') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasCommunication(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Communication') >= 0 ||
      this.permissions.indexOf('Leader') >= 0
    );
  }

  hasPureCommunication(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Communication') >= 0
    );
  }

  hasNotes(): boolean {
    return ( 
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 ||
      this.permissions.indexOf('Notes Limited Access') >= 0 ||
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Note Privacy') >= 0 ||
      this.permissions.indexOf('Notes Full Access') >= 0
    );
  }

  hasMembershipRequests(): boolean {
    return (
      this.permissions.indexOf('Membership Requests') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasMembershipManagement(): boolean {
    return (
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0
    );
  }

  hasBirthday(): boolean {
    return (
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 ||
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Birthday') >= 0
    );
  }

  hasDirectory(): boolean {
    return ( 
      this.permissions.indexOf('Admin') >= 0 ||
      this.permissions.indexOf('Super Admin') >= 0 ||
      this.permissions.indexOf('Profile Editor') >= 0 ||
      this.permissions.indexOf('Leader') >= 0 ||
      this.permissions.indexOf('Membership Management') >= 0 ||
      this.permissions.indexOf('Profile Viewer') >= 0 
    );
  } 

  getMemberId(userId: string) {
    var link = `${this.apiHost}/Permission/GetMemberIdByUserId?UserId=`;
    let promise = new Promise<number>((resolve, reject) => {
      let apiURL = link + userId;
      this.http
        .get<number>(apiURL)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (msg) => {
            resolve(0);
          }
        );
    });
    return promise;
  }

  refreshLeader() {
    if (this.permissions == null) {
      var userData = this.decrypt(localStorage.getItem('userData'));
      if (userData == null)
      {
        this.authenticated = false;
        return;
      }
      var isLeader = userData.isLeader;
      var MemberId = userData.MemberId;
      this.memberId = MemberId;  
      if (isLeader == true) {
        this.permissions = [];
        this.permissions.push('Leader');
      }
    }
  }

  async loadUser(userData: User) {
    if (userData == null || userData.id == null) {
      this.authenticated = false;
      return;
    }
    this.authenticated = true;
    this.id = userData.id;
    this.firstName = userData.firstName;
    this.lastName = userData.lastName;
    this.phone = userData.phoneNumber;
    this.email = userData.email;
    this.token = userData._token; 
    this.permissions = [];
    userData.roles.forEach((a) => this.permissions.push(a));
    this.memberId = userData.memberId;
    if (userData.isLeader == true)
      this.permissions.push('Leader');
    this.tokenExpiration = userData._tokenExpiration;
  }

  IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

encrypt(userData:User):string
{
  try {
  if (userData == null)
  return null;
  var textBytes = aesjs.utils.utf8.toBytes(JSON.stringify(userData));
  var aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
  var encryptedBytes = aesCtr.encrypt(textBytes);
  var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
  return encryptedHex;
  }
  catch {
    return null;
  }
}

decrypt(encryptedHex:string):any
{
  try {
  if (encryptedHex == null)
    return null;
  var encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);
  var aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
  var decryptedBytes = aesCtr.decrypt(encryptedBytes);
  var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
  return JSON.parse(decryptedText);
  }
  catch
  {
    return null;
  }
}
}  
